import React, { Suspense } from "react";
import { Routes, Route, useParams, useLocation } from "react-router-dom";
import { WebsiteProvider } from "../Context/WebSiteContext";
import { predefinedTemplates } from "../Templates/PredefinedTemplates";
import { TemplateProvider } from "../Templates/Context/TemplateContext";
import { useQuery } from "react-query";
import { getSignatures } from "../../../../../services/LandingPages/getSignatures";

function TemplateRouteElement() {
  const { id } = useParams();
  const location = useLocation();

  const signatureId = location?.state?.signature_id;

  // ✅ Evita hook ser chamado com undefined
  const shouldFetch = !!signatureId;

  const queryKey = shouldFetch
    ? ["getSignatures", signatureId]
    : ["getSignatures"];

  const { data, isLoading, error } = useQuery(
    queryKey,
    () => getSignatures(signatureId),
    {
      enabled: shouldFetch,
      staleTime: 1000 * 60 * 5,
      refetchOnWindowFocus: false,
      retry: false, // opcional: evita tentativas automáticas
      onSuccess: (data) => {
        if (data && data.page) {
          // console.log("Data fetched successfully:", data.page);
        } else {
          console.error("No page data found in response");
        }
      },
    }
  );

  const isPreview = location.pathname.endsWith("/preview");

  const defaultConfig = {
    logo: "/logo.png",
    sections: {
      Menu: true,
      Cabeçalho: true,
      Galeria: true,
      Sobre: true,
      Map: true,
      Status: true,
      Loc: true,
      Formulario: true,
      Rodapé: true,
    },
    orderedSections: [
      "Menu",
      "Cabeçalho",
      "Sobre",
      "Galeria",
      "Map",
      "Status",
      "Loc",
      "Formulario",
      "Rodapé",
    ],
    template_id: 1,
    navbar: {
      link_instagram: "lotemobile",
      Tel_Site: "16 99774-2486",
      nav_links: ["Home", "Sobre", "Galeria", "Contato"],
      colornav: "0e1c04",
      colornavtext: "ffffff",
    },
    footer: {
      endereco: "Av. Paulo VI, 781 Franca - SP, 14403-138",
      telefone: "16 99774-2486",
      email: "suporte@ibsystem.com.br",
      facebook: "lotemobile",
      textColorFooter: "000000",
    },
    header: {
      imagemFundo:
        "https://images.unsplash.com/photo-1622322977888-53fd8105fdc4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3MjQ4NzN8MHwxfHNlYXJjaHwxfHxsb3RlYW1lbnRvfGVufDB8fHx8MTc1NTAwNTIxNHww&ixlib=rb-4.1.0&q=85",
      primaryColor: "0e1c04",
      secondaryColor: "FFFFFF",
      nome: "TEMPLATE 1",
      descricao: "Exemplo de site modelo",
    },
    galeria: {
      carousel_upload: "",
      Tittle_carrossel: "Galeria",
      carouselImages: [
        "https://avt.com.br/wp-content/uploads/2023/08/terreno-em-area-urbana.jpg",
        "https://morada.ai/wp-content/uploads/2025/04/Untitled-297-x-210-mm-10.png",
        "https://avt.com.br/wp-content/uploads/2025/02/Terrenos-em-loteamentos-big.jpg",
        "https://images.pexels.com/photos/1250260/pexels-photo-1250260.jpeg?auto=compress&cs=tinysrgb&w=600",
      ],
    },
    statusObra: {
      progressValue: 0,
      progressColor: "#1c1c1c",
      titleColor: "ffffff",
      status_site: "",
      statusList: [
        {
          id: 1744317762433,
          status: "Agua",
          percentage: 60,
        },
        {
          id: 17443117762433,
          status: "Asfalto",
          percentage: 100,
        },
        {
          id: 1744317762433,
          status: "Energia",
          percentage: 90,
        },
        {
          id: 1744317762433,
          status: "Esgoto",
          percentage: 37,
        },
        {
          id: "1755085265534_8851",
          status: "Teste de status",
          percentage: 49,
        },
      ],
      currentStatus: "",
    },
    map: "https://homologation.walletlote.app.br/publicMap/eyJpdiI6InpZWmhmUzNsWitJNG1XZlI4RmNIbFE9PSIsInZhbHVlIjoiMko4ZnpNZnYrRjZuRXY2Y3A0UzVYQT09IiwibWFjIjoiMGFlMGFlZDI1YTgxYjk1N2ZhNDQyZDU5NTBjMWJhMzQxNjgxN2Y4MWRkNmI1YmM3YzRiMzFmODIzNDg2OWVmYSIsInRhZyI6IiJ9",
    formulario: {
      tittle: "Entre em contato conosco",
      email: true,
      phone: true,
      name: true,
    },
    sobreNos: {
      localizacao: "Av. Paulo VI, 781  Franca - SP, 14403-138",
      sobre_empreendimento:
        "Com uma infraestrutura moderna, áreas de lazer e localização estratégica, nosso objetivo é proporcionar um espaço onde conforto, natureza e praticidade se encontram. Aqui, cada lote foi pensado para receber histórias, sonhos e conquistas.\n\nMais do que vender terrenos, queremos criar uma comunidade acolhedora, onde vizinhos se tornam amigos e a vida acontece com tranquilidade e bem-estar.\n\nO [Nome do Loteamento] é o seu convite para construir o futuro que você sempre desejou, em um lugar que une beleza, planejamento e oportunidades.",
      imagem:
        "https://images.unsplash.com/photo-1596709031408-b0b2c9659c8a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3MjQ4NzN8MHwxfHJhbmRvbXx8fHx8fHx8fDE3NTUwMDUzNDR8&ixlib=rb-4.1.0&q=85",
    },
    loc: {
      localizacao:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2952.5903068007447!2d-47.4058177258362!3d-20.55814135817369!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94b0a78ef041a363%3A0xfa2e0280c2b82681!2sibSystem!5e1!3m2!1spt-BR!2sbr!4v1755007200394!5m2!1spt-BR!2sbr",
    },
    primaryColor: "0e1c04",
    secondaryColor: "FFFFFF",
    progressBarColor: "#6ff2e3",
    endereco: "Av. Paulo VI, 781 Franca - SP, 14403-138",
    telefone: "11 111111111",
    email: "suporte@ibsystem.com.br",
    facebook: "lotemobile",
    textColorFooter: "000000",
  };

  let config;
  let templateId;
  let template;
  let fileName;
  let TemplateComponent;

  if (!signatureId && isPreview) {
    // Preview sem assinatura: usa template padrão
    config = defaultConfig;
    templateId = 1;
    template = predefinedTemplates[templateId];
    if (!template) return <div>Template não encontrado</div>;
    fileName = template.route.replace("template", "Template");
    TemplateComponent = React.lazy(() => import(`../Templates/${fileName}.jsx`));
  } else {
    if (!signatureId) return <div>ID da assinatura não foi fornecido.</div>;
    if (isLoading) return <div>Carregando dados da página...</div>;
    if (error) return <div>Erro ao carregar dados</div>;
    if (!data || !data.page) return <div>Página não encontrada</div>;
    template = predefinedTemplates[data.template_id];
    if (!template) return <div>Template não encontrado</div>;
    fileName = template.route.replace("template", "Template");
    TemplateComponent = React.lazy(() => import(`../Templates/${fileName}.jsx`));
    try {
      config = typeof data.page === "string" ? JSON.parse(data.page) : data.page;
      if (!config || Object.keys(config).length === 0) {
        config = defaultConfig;
      }
    } catch (error) {
      console.error("Erro ao fazer parse do JSON da página:", error);
      config = defaultConfig;
    }
    templateId = data.template_id;
  }

  const hideSidebar = location.pathname.endsWith("/preview");

  return (
    <WebsiteProvider initialConfig={config} templateId={templateId}>
      <Suspense fallback={<div>Carregando template...</div>}>
        <TemplateComponent config={config} hideSidebar={hideSidebar} />
      </Suspense>
    </WebsiteProvider>
  );
}

export default function TemplateRoute() {
  return (
    <TemplateProvider>
      <Routes>
        <Route path="" element={<TemplateRouteElement />} />
        <Route path=":id" element={<TemplateRouteElement />} />
        <Route path=":id/preview" element={<TemplateRouteElement />} />
      </Routes>
    </TemplateProvider>
  );
}
